// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import scrollTo from "./components/scrollTo";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import loadGame from "./components/loadGame";
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

document.addEventListener('DOMContentLoaded', function () {

    lazyLoad();

    let myLazyLoad = new LazyLoad();

    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        }
    }

    MobileBurgerMenu();

    // customise table scroll line
    const tables = document.querySelectorAll('.cover-table');
    if (tables.length > 0) {
        tables.forEach((table) => {
            new PerfectScrollbar(table, {
                wheelSpeed: 1,
                minScrollbarLength: 20,
                suppressScrollX: false,
                alwaysShowTracks: true,
                swipeEasing: true,
                clickRail: true,
            });
        });
    }

    // iframe on click
    loadGame();
});


// import custom scripts
import './custom-app'


